<ng-container *ngIf="(state$ | async) as s">
  <div class="upload-widget" *ngIf="s.active" role="status" aria-live="polite">
    <div class="header">
      <span class="title">{{ s.title || 'Subiendo video' }}</span>
      <button class="close" (click)="close()" aria-label="Cerrar">×</button>
    </div>
    <div class="body">
      <div class="phase">{{ getPhaseLabel(s.phase) }}</div>
      <div class="progress">
        <div class="bar" [style.width.%]="s.progress"></div>
      </div>
      <div class="meta">
        <span>{{ s.progress }}%</span>
        <span *ngIf="s.etaSeconds != null">• Tiempo restante {{ s.etaSeconds | secondsToHms }}</span>
      </div>
      <div class="steps">
        <span [class.done]="s.stepUploaded">1. Archivo subido</span>
        <span [class.done]="s.stepAddedToFolder">2. En carpeta</span>
        <span [class.done]="s.stepSaved">3. Guardado</span>
      </div>
      <div class="error" *ngIf="s.error">{{ s.error }}</div>
    </div>
  </div>
</ng-container>
